import { render, staticRenderFns } from "./changeCard.vue?vue&type=template&id=fac8080e&scoped=true&"
import script from "./changeCard.vue?vue&type=script&lang=js&"
export * from "./changeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac8080e",
  null
  
)

export default component.exports